<template>
  <div class="homepage" v-loading="loading">
    <div class="homepage-header-actions">
      <el-tooltip
        v-if="editMode && $canAndRulesPass(user, $permissions.HOME_DASHBOARD.STANDARD_DASHBOARD_MANAGE)"
        content="Настройки стандартных дашбордов"
        placement="top"
        :open-delay="500"
      >
        <el-button
          size="mini"
          class="homepage-header-actions-button"
          icon="fas fa-wrench"
          @click="$refs.homepageStandardDashboardsSettingsDialog.open(standardDashboards);"
        ></el-button>
      </el-tooltip>

      <el-tooltip
        v-if="editMode"
        content="Настройки"
        placement="top"
        :open-delay="500"
      >
        <el-button
          size="mini"
          class="homepage-header-actions-button"
          icon="fas fa-cog"
          @click="$refs.homepageSettingsDialog.open(homepage, dashboards, standardDashboards);"
        ></el-button>
      </el-tooltip>

      <el-tooltip
        v-if="editMode && $canAndRulesPass(currentDashboard, $permissions.HOME_DASHBOARD.WIDGET_MANAGE)"
        content="Добавить виджет"
        placement="top"
        :open-delay="500"
      >
        <el-button
          size="mini"
          class="homepage-header-actions-button"
          icon="fas fa-plus"
          @click="openWidgetPicker"
        ></el-button>
      </el-tooltip>

      <el-button
        size="mini"
        :class="{'is-active': editMode}"
        :icon="'fas fa-' + (editMode ? 'check' : 'pen')"
        @click="editMode=!editMode"
      >
        <span>{{ editMode ? 'Готово' : 'Редактировать' }}</span>
      </el-button>
    </div>


    <el-tabs
      v-if="homepage"
      v-model="currentTab"
      :type="homepage.settings.tabsType"
      :tab-position="homepage.settings.tabsPosition"
      class="homepage-tabs"
      :class="{
        'hidden-header': !homepage.settings.tabsVisible,
        'has-edit-toolbar': editMode,
      }"
    >
      <el-tab-pane
        v-for="dashboard in [...dashboards, ...standardDashboards]"
        :name="dashboard.id.toString()"
        lazy
        :key="dashboard.id"
      >
        <span slot="label">
          <i
            v-if="!dashboard.homepage_id"
            style="margin-right: 5px"
            class="fas fa-lock"
          ></i>
          {{dashboard.settings.name}}
          <el-popconfirm
            v-if="editMode && $canAndRulesPass(user, $permissions.HOME_DASHBOARD.DASHBOARD_MANAGE)"
            confirm-button-text='Да'
            cancel-button-text='нет'
            icon="el-icon-question"
            title="Клонировать дашборд?"
            @confirm="cloneDashboard(dashboard)"
          >
            <el-button
              style="padding:0"
              slot="reference"
              icon="fas fa-copy"
              type="text"
            ></el-button>
          </el-popconfirm>
        </span>
        <HomepageDashboard
          v-if="dashboard.id===parseInt(currentTab)"
          :dashboard="dashboard"
          :dashboards="dashboards"
          :edit-mode="editMode"
          :ref="'dashboard_'+dashboard.id"
        ></HomepageDashboard>
      </el-tab-pane>
    </el-tabs>


    <HomepageSettingsDialog
      ref="homepageSettingsDialog"
      @saved="loadHomepage"
    />

    <HomepageStandardDashboardsSettingsDialog
      ref="homepageStandardDashboardsSettingsDialog"
      @saved="loadHomepage"
    />


  </div>
</template>

<script>


import HomepageDashboard from "@/components/home/dashboard/HomepageDashboard.vue";
import HomepageSettingsDialog from "@/components/home/dashboard/HomepageSettingsDialog.vue";
import HomepageStandardDashboardsSettingsDialog
  from "@/components/home/dashboard/HomepageStardardDashboardsSettingsDialog.vue";
import {mapGetters} from "vuex";

export default {
  name: 'Homepage',
  components: {HomepageStandardDashboardsSettingsDialog, HomepageSettingsDialog, HomepageDashboard},
  computed: {
    ...mapGetters([ 'user' ]),
    currentDashboard(){
      return this.dashboards.concat(this.standardDashboards).find(d => d.id === +this.currentTab);
    },
  },
  data() {
    return {
      loading: false,
      editMode: false,
      currentTab: null,

      homepage: null,
      dashboards: [],
      standardDashboards: [],
    };
  },
  mounted() {
    this.loadHomepage();
  },
  methods: {
    loadHomepage(){
      this.loading = true;
      this.$api.homeDashboard.getHomepage({
        expand: 'permissions'
      })
        .then((data) => {
          this.homepage = data.homepage;
          this.dashboards = data.dashboards;
          this.standardDashboards = data.standard_dashboards;

          this.currentTab = this.findCurrentTab();
        })
        .finally(()=>{
          this.loading = false;
        })
    },

    findCurrentTab(){
      if( this.homepage.default_dashboard_id ){
        return this.homepage.default_dashboard_id.toString();
      }

      if( this.standardDashboards.length ){
        return this.standardDashboards[0]?.id?.toString();
      }

      return this.dashboards[0]?.id?.toString();
    },

    cloneDashboard(dashboard){
      this.$api.homeDashboard.cloneDashboard({
        dashboard_id: dashboard.id,
      })
        .finally(() => {
          this.loadHomepage();
        })
    },

    openWidgetPicker(){
      if( !this.currentTab ){
        return;
      }

      this.$refs['dashboard_'+this.currentTab][0].openWidgetPicker();
    }


  }
};
</script>


<style lang="scss">
@import "@/assets/css/element-variables";
@import "@/components/home/dashboard/_dashboard-design";

.homepage{
  position: relative;

  &-header-actions{
    position: absolute;
    top: -6px;
    right: 0;
    z-index: 2;
    display: flex;
    align-items: center;
    gap: $dashboard-space-xs;
    background-color: $dashboard-surface;
    border: 1px solid $dashboard-border-color;
    border-radius: $--border-radius-base;
    padding: $dashboard-space-xs;
  }

  .el-tabs--top .el-tabs__item.is-top:last-child, .el-tabs--top .el-tabs__item.is-bottom:last-child, .el-tabs--bottom .el-tabs__item.is-top:last-child, .el-tabs--bottom .el-tabs__item.is-bottom:last-child{
    padding-right: 20px !important;
  }
  .el-tabs--top .el-tabs__item.is-top:nth-child(2), .el-tabs--top .el-tabs__item.is-bottom:nth-child(2), .el-tabs--bottom .el-tabs__item.is-top:nth-child(2), .el-tabs--bottom .el-tabs__item.is-bottom:nth-child(2){
    padding-left: 20px !important;
  }
  &-tabs{
    &.hidden-header .el-tabs__header{
      display: none;
    }

    .el-tabs__content{
      overflow: inherit;
    }


    &.el-tabs--top .el-tabs__nav-wrap,
    &.el-tabs--bottom .el-tabs__nav-wrap{
      padding-right: 100px;
    }

    &.has-edit-toolbar.el-tabs--top .el-tabs__nav-wrap,
    &.has-edit-toolbar.el-tabs--bottom .el-tabs__nav-wrap{
      padding-right: 230px;
    }

    .el-tabs__nav-wrap::after{
      display: none;
    }

    .el-tabs__active-bar{
      display: none;
    }

    .el-tabs__item{
      border-radius: $--border-radius-base;
      border: 1px solid $--color-primary-light-5;
      background-color: #fff;
      font-size: 12px;
      height: 30px;
      line-height: 30px;
      margin: 0 10px;
      transition: background-color .15s ease, color .15s ease;

      &.is-active{
        background-color: mix($dashboard-surface, $--color-primary, 90%);
        color: $--color-primary;
        font-weight: 600;
      }
    }
  }

}

</style>`